import angular from 'angular';

import UsersService from './users.service';
import UserVisibilityDirective from './user-visiblity.directive';

export default angular.module('autoboard.users', [UsersService, UserVisibilityDirective])
  .name;
